// extracted by mini-css-extract-plugin
module.exports =  {"placement":"placements-module_placement_a5937","accordionHeader":"placements-module_accordionHeader_d89a2"};